export const currency = new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2
});

export const formatPhone = str => {
    let match = ('' + str).replace(/\D/g, '').match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
    return null
};

export const shortHandDate = (date) => {
    return new Date(date).toLocaleDateString(navigator.language, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

export const shortHandDateTime = (date) => {
    const time = new Date(date).toLocaleTimeString(navigator.language, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    })
    return `${shortHandDate(date)} - ${time}`
};

export const generateId = (l = 7) => Array.from({ length: l }, () => String.fromCharCode(Math.random() > 0.5 ? randomIntBetween(65, 90) : randomIntBetween(97, 122))).join('');

export const randomIntBetween = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

export const duplicateSort = (o, k) => o.sort((a, b) => o.filter(e => e[k] === b[k]).length - o.filter(e => e[k] === a[k]).length);

export const between = (num, minN, maxN) => Math.min(Math.max(num, minN), maxN);

export const categorySort = (a, b) => {
    const catEnum = {
        'AppClub': 0,
        'AppBundle': 1,
        'AppWash': 2,
        'GiftCard': 3,
        'Swag': 3
    }

    return catEnum[a] - catEnum[b];
}

export const lastKeyPress = {
    keyInternal: null,
    keyListener: val => { },
    set key(val) {
        this.keyInternal = val;
        this.keyListener(val);
    },
    get key() {
        return this.keyInternal;
    },
    registerListener: function (listener) {
        this.keyListener = listener;
    }
}

export const htmlDecode = input => {
    const e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};

export const timeAgo = date => {
    const now = Date.now();
    const seconds = (now - date) / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const months = days / 30;
    const years = days / 365;

    if (seconds < 5) {
        return 'now';
    } else if (seconds < 60) {
        return `${Math.floor(seconds)}s`;
    } else if (minutes < 60) {
        return `${Math.floor(minutes)}m`;
    } else if (hours < 24) {
        return `${Math.floor(hours)}h`;
    } else if (days < 30) {
        return `${Math.floor(days)}d`;
    } else if (months < 12) {
        return `${Math.floor(months)}mo`;
    } else {
        return `${years.toFixed(1)}y`;
    }
}

export const EU = word => {
    switch (word) {
        case 'AppWash':
            return 'Single Wash';
        case 'AppBundle':
            return 'Bundle Codes';
        case 'AppClub':
            return 'Wash Club';
        case 'AppPoints':
            return 'Awards';
        case 'DollarDiscTrans':
            return 'Discount Code';
        case 'Item':
            return 'Redeemed Wash';
        default:
            return word;
    }
}

export const EUG = word => {
    switch (word) {
        case 'Single Wash':
            return 'car';
        case 'Bundle Codes':
            return 'tag';
        case 'Wash Club':
            return 'calendar';
        case 'Awards':
            return 'gift';
        case 'Discount Code':
            return 'dollarSign';
        case 'Loyalty':
            return 'award';
        default:
            return word;
    }
}

export const mobileView = window.innerWidth < 1200;

export const isMobile = (agent) => {
    if (window.location.href.match('#MAC')) {
        return true;
    }
    if (window.deviceToken) {
        return true;
    }
    if (!agent) agent = navigator.userAgent;
    let check = false;
    // eslint-disable-next-line no-useless-escape
    (function (a) { if (/android|(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const OSs = {
    IOS: 'iOS',
    MAC: 'Mac OS',
    Windows: 'Windows',
    Android: 'Android',
    Linux: 'Linux',
}

export const getOS = () => {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (/Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}

export const plural = (numberOf, word) => `${word}${numberOf > 1 ? 's' : ''}`

export const updateNestedObjProp = (obj, path, value) => {
    if (!(path instanceof Array)) path = path.split('.');
    if (path.length === 1) {
        obj[path] = value;
        return
    }
    return updateNestedObjProp(obj[path[0]], path.slice(1), value)
}

export const shallowCompare = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2)

export const schemafy = (obj, ver) => {
    const schema = {
        "$schema": "https://json-schema.org/draft/2019-09/schema",
        "additionalProperties": false,
        "version": ver
    };
    const drillDown = (obj, schema = {}) => {
        schema.type = obj instanceof Array ? 'array' : typeof obj;
        if (schema.type === 'object') {
            schema.additionalProperties = false;
            schema.required = Object.keys(obj);
            schema.properties = {};
            schema.required.forEach(e => schema.properties[e] = drillDown(obj[e]));
        } else if (schema.type === 'array') {
            schema.items = {};
            obj.forEach(e => schema.items = drillDown(e));
        } else {
            schema.default = obj;
        }
        return schema;
    };
    return drillDown(obj, schema);
}

export const pascalCase = string => string.replace(/(^|\s)\S/g, e => e.toUpperCase());

export const gradient = (color1, color2, ratio) => {
    const from = hex2rgb(color1)
    const to = hex2rgb(color2)

    const r = Math.ceil(to.r * ratio + from.r * (1 - ratio));
    const g = Math.ceil(to.g * ratio + from.g * (1 - ratio));
    const b = Math.ceil(to.b * ratio + from.b * (1 - ratio));

    return `#${hex(r)}${hex(g)}${hex(b)}`;
}

const hex2rgb = color => {
    const hex = color.replace('#', '')
    return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16),
    }
}

const hex = num => num.toString(16).padStart(2, '0');

export const hexComplementary = h => h.match(/\w./g).map(e => hex(255 - parseInt(e, 16))).join('');

export const getDaysInMonth = (month, year = 2000) => new Date(year, month, 0).getDate();

export const getSubdomain = () => window.location.host.split('.')[1] ? window.location.host.split('.')[0] : null;

export const toggleArrayElement = (arr, element) => {
    if (!(arr instanceof Array)) {
        console.warn('Not an instance of an Array', arr);
        return;
    }
    const index = arr.indexOf(element);
    index === -1 ? arr.push(element) : arr.splice(index, 1);
}

Array.prototype.joinComponent = function (component) {
    return this.flatMap((item, index) => index < this.length - 1 ? [item, component] : [item]);
};